export const PLAN_SIDEBAR_NAVIGATION_OPTIN_STATUS =
	'RESOURCE_TYPE_PLAN_SIDEBAR_NAVIGATION_OPTIN_STATUS';
